// @ts-strict-ignore
import styled from 'styled-components/native'
import React from 'react'
import { MessageContainerProps, StyledViewProps } from './types'

const RADIUS_DEFAULT = 16
const RADIUS_GROUPED = 8

const MessageWrapper = styled.View<StyledViewProps>`
  position: relative;
  background: ${({ theme: { colors }, color }) => colors[color]};
  padding: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  border-radius: ${RADIUS_DEFAULT}px;
  border-top-${({ position }) => position}-radius: ${({ topRadius }) => topRadius}px;
  border-bottom-${({ position }) => position}-radius: ${({ bottomRadius }) => bottomRadius}px;
  max-width: ${({ theme: { isBigScreen } }) => (isBigScreen ? '600px' : '240px')};
`

export const MessageContainer = ({
  children,
  rtl,
  isError,
  previousPostIsSameUser,
  nextPostIsSameUser,
  previousPostIsSameDay,
  nextPostIsSameDay,
}: MessageContainerProps) => {
  const position = rtl ? 'right' : 'left'
  const color = isError ? 'disabled' : rtl ? 'patientMsgBg' : 'practitionerMsgBg'
  const topRadius = previousPostIsSameUser && previousPostIsSameDay ? RADIUS_GROUPED : 0
  const bottomRadius = nextPostIsSameUser && nextPostIsSameDay ? RADIUS_GROUPED : RADIUS_DEFAULT
  return (
    <MessageWrapper
      position={position}
      color={color}
      topRadius={topRadius}
      bottomRadius={bottomRadius}
    >
      {children}
    </MessageWrapper>
  )
}
